import { SERVER_API } from "../../Constant";
import axios from "axios";

export const FetchInquiryNumber_api = async (
  keyword: string | null = null,
  statusCheck: boolean = false,
  page = 1,
  limit = 10,
) => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Payments/fetch_inquirynumber.php`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          keyword: keyword || null,
          statusCheck: statusCheck || false,
          page,
          limit,
        },
      },
    );

    return response.data;
  } catch (error: any) {
    console.error("Fetch inquiry number failed:", error);
    return { error: "Fetch inquiry number failed" };
  }
};
